import apiTool from './index';

const GET_USER_DOCUMENTATION_URL = 'documentation/get-documentation/';

export default {
  getUserDocumentation() {
    return apiTool.get(GET_USER_DOCUMENTATION_URL);
  },
};
